import CheckboxSelectionProcessor from '../../Components/Core/Processors/CheckboxSelectionProcessor'
import MultiLegSelectionResultProcessor from '../../Components/Core/SelectionResults/MultiLegSelectionResultProcessor'
import MultiLegValidator from '../../Validation/MultiLegValidator'
import BetTypeInformation from '../Betting/BetTypeInformation'
import type { IConfigureBetType } from './IConfigureBetType'

export default class DoubleConfigurator implements IConfigureBetType {
  build(): BetTypeInformation {
    return new BetTypeInformation({
      betType: 'Double',
      name: 'Double',
      supportsFlexi: true,
      sortOptions: ['Number', 'FixedPrice', 'Price'],
      template: 'multi-leg-template',
      betSelectionTemplate: 'dual-checkbox-selection-template',
      multiBet: true,
      multiSelections: true,
      processor: new CheckboxSelectionProcessor(1),
      validator: new MultiLegValidator(2),
      selectionResultProcessor: new MultiLegSelectionResultProcessor(),
      checkBoxCount: 1,
      fieldCheckBoxCount: 2,
      sameAsCheckBoxCount: 0,
      legs: 2,
    })
  }
}
